<div class="gap-xxs flex w-full flex-col">
  <label [for]="stepperId()" [class.text-components-content-neutral-quaternary]="disabled()" hlmLabel>{{
    label()
  }}</label>
  <div class="px-xxxs py-sm" [id]="stepperId()" [class.!border-feedback-negative-main]="invalid()" hlmInputGroup>
    <button [disabled]="!canDecrement()" (click)="decrement()" size="xxl" hlmBtn variant="ghost" aria-label="Diminuer">
      <ng-icon hlm name="lucideMinus" size="sm" />
    </button>
    <input
      class="text-center"
      [value]="value() ?? ''"
      [attr.min]="min()"
      [attr.max]="max()"
      [attr.step]="step()"
      [placeholder]="placeholder()"
      [disabled]="disabled()"
      (input)="onInput($event)"
      (blur)="onBlur()"
      data-slot="input-group-control"
      hlmInputGroupInput
      type="number"
    />
    <button [disabled]="!canIncrement()" (click)="increment()" size="xxl" variant="ghost" aria-label="Augmenter" hlmBtn>
      <ng-icon hlm name="lucidePlus" size="sm" />
    </button>
  </div>
  @if (invalid()) {
    <hlm-field-error>{{ errorMessage() }}</hlm-field-error>
  }
</div>
